import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import React from 'react';
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import App from './components/App';
import { Config } from './config';
import { HttpCodes } from './enums/httpCodes';
import './index.scss';
import {configureAmplify, configureRUM, isNotDev} from './utils';
import { forceRedirectToHttps } from './utils/forceHttps';

// Force redirect to https
forceRedirectToHttps();

fetch(`${Config.API}/web_config`)
  .then(
    (res) => {
      if (res.status === HttpCodes.MAINTENANCE) {
        window.location.href = 'maintenance.html';
      } else {
        return res.json();
      }
    },
    () => alert('Something went wrong!'),
  )
  .then((config) => {
    Config.GoogleApiKey = config.google_api_key;
    Config.MapboxApiKey = config.mapbox_api_key;
    Config.AppClientID = config.cognito_app_client_id;
    Config.CognitoAuthUrl = config.cognito_auth_url;
    Config.UserPoolID = config.cognito_user_pool_id;
    Config.AWSRegion = config.aws_region;
    Config.StageName = config.stage_name;

    configureAmplify();

    if (isNotDev()) {
      configureRUM();
    }

    ChartJS.register(ArcElement, Tooltip, Legend, LinearScale, CategoryScale, BarElement, Title, Tooltip, Legend);

    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(<App />);
  });
